import { atom } from 'recoil';

export const toggleSamRequest = atom({
    key: 'aws-edap-aksn-toggleSamRequest',
    default: false,
});

export const toggleQuickConfig = atom({
    key: 'aws-edap-aksn-toggleQuickConfig',
    default: false,
});

export const defaultVmDataDisk = atom({
    key: 'aws-edap-aksn-defaultVmDataDisk',
    default: undefined,
});
export const isDataDiskLoaded = atom({
    key: 'aws-edap-aksn-isDataDiskLoaded',
    default: false,
});
export const defaultOsDiskType = atom({
    key: 'aws-edap-aksn-defaultOsDiskType',
    default: undefined,
});
export const quickConfigDetails = atom({
    key: 'aws-edap-aksn-quickConfigDetails',
    default: undefined,
});
export const toggleSspModels = atom({
    key: 'aws-edap-aksn-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isDiskOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
        isErrorCode: false,
    },
});

export const isValidappSupportMailId = atom({
    key: 'aws-edap-aksn-isValidappSupportMailId',
    default: false,
});

export const isEnvDetailsLoading = atom({
    key: 'aws-edap-aksn-isEnvDetailsLoading',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'aws-edap-aksn-isConfigDiskFulfilled',
    default: false,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'aws-edap-aksn-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'aws-edap-aksn-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'aws-edap-aksn-sspOrder',
    default: {
        appProfile: null,
        appProfileDetails: null,
        applicationOwner: null,
        applicationOwnerDetails: null,
        entityDetails: null,
        applicationName: null,
        appShortName: null,
        sector: null,
        environment: null,
        region: null,
        program: null,
        programDetails: null,
        regionDetails: null,
        appSupportMailId: null,
        eksNamespace: null,
        department: null,
        departmentDetails: null,
        cluster: null,
        clusterDetails: null,
        project: '',
        hCode: null,
        hCodeDetails: null,
        adGroup: null,
        envDetails: null,
        tags: [],
        estimatedCost: {
            qty: 1,
            totalRecurringCost: {
                item: 'Total Recurring',
                frequency: 'monthly',
                estCost: 0,
                currency: 'USD',
            },
            totalOneTimeCost: {
                item: 'Total One Time',
                frequency: 'One Time',
                estCost: 0,
                currency: 'USD',
            },
        },
        validationStatus: 'clearValidation',
        requestType: '',
        isTouched: false,
    },
});

export const environmentDetails = atom({
    key: 'aws-edap-aksn-environmentDetails',
    default: {
        Project: '-',
        Approval_Manager: '-',
        'ISA Document': '-',
    },
});
export const toggleCurrentServer = atom({
    key: 'aws-edap-aksn-toggleCurrentServer',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'aws-edap-aksn-CurrentServerDetails',
    default: null,
});
export const validationErrorCode = atom({
    key: 'aws-edap-aksn-validationErrorCode',
    default: null,
});

export const costEstimateState = atom({
    key: 'aws-edap-aksn-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aws-edap-aksn-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isCostcenterValid = atom({
    key: 'aws-edap-aksn-isCostcenterValid',
    default: false,
});

export const isNamespaceNameValid = atom({
    key: 'aws-edap-aksn-isNamespaceNameValid',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'aws-edap-aksn-isAppUrlValid',
    default: false,
});

export const isAdGroupValid = atom({
    key: 'aws-edap-aksn-isAdGroupValid',
    default: false,
});

export const isAppNameValid = atom({
    key: 'aws-edap-aksn-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'aws-edap-aksn-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'aws-edap-aksn-isAppShortNameExist',
    default: false,
});
